"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Dropdown = _interopRequireDefault(require("react-bootstrap/Dropdown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DropdownItemCustom = (type, allProps) => {
  const {
    caption,
    children,
    defaultChecked,
    id,
    name,
    onClick,
    ...props
  } = allProps;
  const clickHandler = e => {
    e.stopPropagation();
    if (onClick) {
      onClick(e, {
        id,
        name,
        label: children
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default.Item, _extends({
    as: "div"
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: `custom-control custom-${type}`
  }, /*#__PURE__*/_react.default.createElement("input", {
    defaultChecked: defaultChecked,
    className: "custom-control-input",
    id: id,
    name: name,
    onClick: clickHandler,
    type: type
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label",
    htmlFor: id,
    onClick: e => e.stopPropagation()
  }, children, caption && /*#__PURE__*/_react.default.createElement("span", {
    className: "caption"
  }, "\xA0", caption))));
};
var _default = exports.default = DropdownItemCustom;